<template>
  <div
    style="text-align: center;"
    :style="{ color: color, fontWeight: fontWeight, fontSize: fontSize, margin: margin }"
    :class="fontFamily"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'UiLegend',
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#53627C',
    },
    fontWeight: {
      type: Number,
      default: 400,
    },
    fontSize: {
      type: String,
      default: '18px',
    },
    margin: {
      type: String,
      default: '16px',
    },
    fontFamily: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.alt {
  font-family: $font-family-footer;
}
</style>
